import React, { useState, useEffect, ChangeEvent, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./component.css";
import { DocData, mediaData } from "../utils/types";
import {
  ADD_MEDIA_FILE,
  GET_ALL_ACCESSIBLE_MEDIA,
} from "../utils/constants";
import {
  makeAuthenticatedGet,
  makeAuthenticatedPost,
  makeAuthenticatedPostForFile,
} from "../utils/fetchUtils";
import { useNavigate } from "react-router-dom";
import { Bounce, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import uploadImg from "../assets/upload-img.svg";
import or from "../assets/or.svg";
import downArrow from "../assets/down-arrow.svg";
import useWindowWidth from "../utils/windowWidth";


const AVAccessibilityForm = (props: any) => {
  const navigate = useNavigate();

  const inputRef = useRef<HTMLInputElement>(null);
  
  // react states
  const [formData, setFormData] = useState<mediaData>({
    file: null,
    tag: "",
    fileName: "",
  });
  const [isDirty, setIsDirty] = useState(true);
  const [fileName, setFileName] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [allTags,setAllTags] = useState<any[]>([]);
  const [downshiftMenu, setDownShiftMenu] = useState<any[]>([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);


  //drag to upload
    const [dragging, setDragging] = useState(false);
  
    // Handlers for drag events
    const handleDragEnter = (e: any) => {
      e.preventDefault();
      e.stopPropagation();
      setDragging(true);
    };
  
    const handleDragLeave = (e: any) => {
      e.preventDefault();
      e.stopPropagation();
      setDragging(false);
    };
  
    const handleDragOver = (e: any) => {
      e.preventDefault();
      e.stopPropagation();
    };
  
    const handleDrop = (e: any) => {
      e.preventDefault();
      e.stopPropagation();
      setDragging(false);
  
      if (e.dataTransfer.files.length > 1) {
        alert("Please drag and drop only one file at a time.");
        return;
      }
  
      const droppedFile = e.dataTransfer.files[0]; // Get the first file
      if (droppedFile) {
        setFileName(droppedFile.name);
        setFormData({
          ...formData,
          file: droppedFile.name,
          fileName: droppedFile.name,
        });
      } else {
        setFileName(droppedFile.name);
        setFormData({
          ...formData,
          fileName: droppedFile.name,
        });
      }
    };

  // const handleOptionChange = (event: any) => {
  //   setSelectedOption(event.target.value);
  //   handleChange(event);
  // };

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if(name === 'tag') {
      const filteredItems = (value ===''?allTags:(allTags.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())))
      );
      setDownShiftMenu(filteredItems);
    }
    
  };

  const onInputFocus = () => {
    setIsDropdownOpen(true);
  };

  const onInputBlur = ()=> {
    setTimeout(()=>{
      setIsDropdownOpen(false);
    },1000);
    
  }

  const toggleTagInputFocus = ()=> {
    if (inputRef.current) { 
      if(!isDropdownOpen) {
        inputRef.current.focus();
      } else {
        inputRef.current.blur();
      }
      
    }
  }

  const handleDropdownItemClick = (value: any) => {
    console.log(value);
    setFormData({
      ...formData,
      tag: value,
    });
    setIsDropdownOpen(false);
  };

  const fetchMedia = async () => {
    try {
      const url = GET_ALL_ACCESSIBLE_MEDIA;
      const response = await makeAuthenticatedGet(url);
      const temp = response;
      const tags: any[] = [];
      temp.documents.map((doc: any) => {
        tags.push(doc.tag);
      });
      setAllTags(tags);
      setDownShiftMenu(tags);
    } catch (error: any) {
      console.error("Error fetching books: ", error);
    }
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      setFileName(file.name);
      setFormData({
        ...formData,
        file: files ? files[0] : null,
        fileName: file.name,
      });
    } else {
      setFileName(event.target.value);
      setFormData({
        ...formData,
        fileName: event.target.value,
      });
    }
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const data = new FormData();
    data.append("tag", formData.tag);
    if (formData.file) {
      data.append("audio", formData.file);
    }
    console.log("Form data:", formData);
    console.log(data);

    //API Call
    const url = ADD_MEDIA_FILE;

    makeAuthenticatedPostForFile(url, data)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => console.log("error uploading file", error));
    console.log("post successful");
    navigate("/avaccess/uploading");
  };


  //use Effects

  useEffect(() => {
    const isNotDirty = formData.file != null;
    setIsDirty(!isNotDirty);
  }, [formData]);

  useEffect(() => {
    fetchMedia();
  }, []);
  
  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;


  return (
    <>
      <form className="doc-form upload-doc-form" onSubmit={handleSubmit} aria-live="polite">
        {fileName!=='' && (
            <div role="alert" aria-live="polite" className="d-flex w-[90%] doc-upload-alert mb-5">
              <p>Media Uploaded Successfully!</p>
            </div>
          )}
        <div className="mb-3 input-div">
          <h2 id="formFileLabel" className="form-label">
            {formData.file === null ? "Upload Media" : "File uploaded"}
          </h2>
          <p>Add your Audio/Video here</p>
          <section
            tabIndex={0}
            className="upload-input-container"
            onDragEnter={handleDragEnter}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            aria-label="Drag and drop a file here or click to browse"
            aria-live="polite"
          >
            <img src={uploadImg} alt="Upload icon" />
            <p style={{ fontSize: "1rem", color: "#000000" }}>
              Drag your file to start uploading
            </p>
            <img src={or} alt="" />
            <input
              className="form-control input-1"
              type="file"
              id="formFile"
              onChange={handleFileChange}
              name="file"
              accept=".mp3,.wav,.aac,.flac,.ogg,.wma,.m4a,.midi,.mp4,.avi,.mov,.wmv,.mkv,.flv"
              aria-describedby="fileHelp"
              aria-labelledby="formFileLabel"
              required
            />
            <button  className="upload-button"
              type="button"
              onClick={() => document?.getElementById('formFile')?.click()}
            >
            {fileName === "" ? "Browse files" : "Change File"}
            
            </button>
            <p
              className="filename"
              style={{ fontSize: "0.75rem", padding: "0", margin: "0" }}
            >
              {fileName}
            </p>
          </section>
          <p id="fileHelp">
            Supported Input Formats: Video and audio formats. Max file size
            limit - 200 mb
          </p>
          {/* <p className="filename">{fileName}</p> */}
        </div>  
        <div className="mb-3 input-div" style={{ width: isMobile?"100%":'50%'}}>
          <label htmlFor="tagS">
            <h2 id="tag-label" className="form-label">
              Tag (Optional)
            </h2>
          </label>
          <div className="tag-dropdown" aria-live="off">
            <label htmlFor="tagSuggestions">
              <p id="tagInstructions">
                Choose existing tag or create new tag for this request by typing
                new value
              </p>
            </label>
            <div
              className="downshift-div dropdown"
              role="combobox"
              aria-haspopup="listbox"
              aria-owns={isDropdownOpen ? "downshift-35-menu" : undefined}
              aria-expanded={isDropdownOpen}
              aria-controls="downshift-35-menu"
            >
              <input
                ref={inputRef}
                className="downshift-input form-control input-3"
                id="tag"
                aria-autocomplete="list"
                aria-controls={isDropdownOpen ? "downshift-35-menu" : undefined}
                aria-labelledby="tag-label"
                name="tag"
                value = {formData.tag}
                onChange={handleChange}
                onFocus={onInputFocus}
                onBlur={onInputBlur}
                title="Enter a tag"
              />
              <button
                className={`downshift-toggle-button ${isDropdownOpen ? 'show' : ''}`}
                type="button"
                // onClick={toggleInputFocus}
                // data-bs-toggle="dropdown"
                onClick={toggleTagInputFocus}
                aria-expanded={isDropdownOpen}
                  aria-label={isDropdownOpen ? "Close tag options" : "Open tag options"}
                  title={isDropdownOpen ? "Close tag options" : "Open tag options"}
              >
                <svg
                  className="MuiSvgIcon-root"
                  focusable="false"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M7 10l5 5 5-5z"></path>
                </svg>
              </button>
              <div className="dropdown">
              {isDropdownOpen && downshiftMenu.length && <ul className="dropdown-menuu" id="downshift-35-menu" role="listbox">
              {downshiftMenu.map((li, index) => {
                return (
                  <li
                    className="downshift-item dropdown-item"
                    role="option"
                    aria-selected="false"
                    id="downshift-35-item-0"
                    style={{}}
                    key={index}
                    onClick={()=>handleDropdownItemClick(li)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        handleDropdownItemClick(li);
                      }
                    }}
                  >
                    {li}
                  </li>
                );
              })}
              </ul>}
            </div>
            </div>  
          </div>
        </div>
        {/* <footer className="form-footer">
          <button
            type="submit"
            className="btn btn-primary btn-center submit"
            onClick={handleSubmit}
            disabled={isDirty}
          >
            Submit
          </button>
        </footer> */}
      </form>
      <div style={{ width: '100%',paddingTop: '2rem' }} className="d-flex items-center justify-center">
        <button
          tabIndex={0}
          type="submit"
          className="doc-submit"
          disabled={isDirty}
          // onSubmit={handleSubmit}
          onClick={handleSubmit}
        >
          Convert Audio/Video
        </button>
        {isDirty && (
          <p
            id="disabledReason"
            style={{ fontSize: "0.75rem" }}
            className="sr-only"
            tabIndex={0}
          >
            Please fill out all required fields to enable the button.
          </p>
        )}
      </div>
    </>
  );
};

export default AVAccessibilityForm;
